import { Link } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";

export function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <h1 className="display-mono text-6xl text-magenta mb-2">404</h1>
        <p className="text-sm text-text-muted mb-6">Esta ruta no existe</p>
        <Link to="/">
          <Button>Ir al inicio</Button>
        </Link>
      </div>
    </div>
  );
}
